import { combineReducers } from '@reduxjs/toolkit';
import userSlice from './slice/user/userSlice';
import authSlice from './slice/auth/authSlice';
import sportsSlice from './slice/sports/sportsSlice';
import eventsSlice from './slice/events/eventsSlice';
import userDownlineSlice from './slice/userDownlineList/usersSlice';
import userBankingReducer from './slice/userBanking/userBankingSlice';
import adminFundReducer from './slice/adminFund/adminFundSlice';
import newsReducer from './slice/news/newsSlice';
import bannerReducer from './slice/banner/bannerSlice';
import accountStatementReducer from './slice/accountStatement/accountStatementSlice';
import profitLossReducer from './slice/profitLoss/profitLossSlice';
import betHistoryReducer from './slice/betHistory/betHistorySlice';
import openBetsReducer from './slice/openBets/openBetsSlice';
import blockMarketsReducer from './slice/blockMarkets/blockMarkets';
import userGeneralSettingReducer from './slice/userGeneralSetting/userGeneralSettingSlice';
import eventUserGeneralSettingReducer from './slice/eventUserGeneralSetting/eventUserGeneralSettingSlice';
import marketAnalysisReducer from './slice/marketAnalysis/marketAnalysisSlice'
import chipSummaryReducer from './slice/chipSummary/chipSummarySlice'
import clientPLReducer from './slice/clientPL/clientPLSlice'
import marketPLReducer from './slice/marketPL/marketPLSlice'
import sportPLReducer from './slice/sportPL/sportPLSlice'
import eventMarketPLReducer from './slice/eventMarketPL/eventMarketPLSlice'
import eventMarketBetsReducer from './slice/eventMarketBets/eventMarketBetsSlice'
import matchPLReducer from './slice/matchPL/matchPLSlice'
import fancyExposureReducer from './slice/fancyExposure/fancyExposureSlice'
import changeUserStatusReducer from './slice/changeUserStatus/changeUserStatusSlice'
import changeBetSettingReducer from './slice/changeBetSetting/changeBetSettingSlice'
import fancySaleReducer from './slice/fancySale/fancySaleSlice'
import matchSaleReducer from './slice/matchSale/matchSaleSlice'
import bettingReducer from './slice/betting/bettingSlice'
import fancyDataSlice from './slice/fancyData/fancyDataSlice';
import chipsSlice from './slice/chips/chipsSlice';

const rootReducer = combineReducers({
  userbal: userSlice,
  authSlice: authSlice,
  sports: sportsSlice,
  events: eventsSlice,
  userDownline: userDownlineSlice,
  userBanking: userBankingReducer,
  adminFund: adminFundReducer,
  news: newsReducer,
  banner: bannerReducer,
  accountStatement: accountStatementReducer,
  profitLoss: profitLossReducer,
  betHistory: betHistoryReducer,
  openBets: openBetsReducer,
  blockMarkets: blockMarketsReducer,
  userGeneralSetting: userGeneralSettingReducer,
  eventUserGeneralSetting: eventUserGeneralSettingReducer,
  marketAnalysis: marketAnalysisReducer,
  chipSummary: chipSummaryReducer,
  clientPL: clientPLReducer,
  marketPL: marketPLReducer,
  sportPL: sportPLReducer,
  matchPL: matchPLReducer,
  eventMarketPL: eventMarketPLReducer,
  eventMarketBets: eventMarketBetsReducer,
  fancyExposure: fancyExposureReducer,
  changeUserStatus: changeUserStatusReducer,
  changeBetSetting: changeBetSettingReducer,
  fancySale: fancySaleReducer,
  matchSale: matchSaleReducer,
  betting: bettingReducer,
  fancyData: fancyDataSlice,
  chips: chipsSlice
});

export default rootReducer;
